import { bool, func, string } from 'prop-types';
import React from 'react';
import { GoSync } from 'react-icons/go';
import Moment from 'react-moment';
import { Button } from 'reactstrap';

import { taskShape } from '../../prop-types';
import api from '../../REST/api';
import withApiRequest from '../../REST/with-api-request';
import Loading from '../Loading';
import { TASK_STATUSES } from './constants';

class TaskStatus extends React.PureComponent {
  constructor(props) {
    super(props);

    this.checkTaskStatus = this.checkTaskStatus.bind(this);
  }

  checkTaskStatus() {
    const {
      onRequest,
      onUpdateTaskStatus,
      task: { taskId },
    } = this.props;

    return onRequest({ id: taskId }).then(onUpdateTaskStatus);
  }

  render() {
    const { status, lastModified } = this.props.task;
    const { loading, taskName } = this.props;

    if (loading) {
      return <Loading className="m-0 p-0 border-0 text-info" />;
    }

    switch (status) {
      case TASK_STATUSES.SUCCESS:
        return (
          <span className="text-success">
            {taskName} was completed successfully{' '}
            <Moment fromNow>{lastModified}</Moment>.
          </span>
        );

      case TASK_STATUSES.FAILURE:
        return (
          <span className="text-danger">
            {taskName} encountered an error. Please try again.
          </span>
        );

      case TASK_STATUSES.RECEIVED:
      case TASK_STATUSES.STARTED:
      case TASK_STATUSES.RETRY:
      default:
        return (
          <span className="text-info">
            {taskName} is in progress.
            <Button
              onClick={this.checkTaskStatus}
              className="ml-3"
              size="sm"
              data-name="task-status-check"
              color="info"
              outline
            >
              Check progress <GoSync />
            </Button>
          </span>
        );
    }
  }
}

TaskStatus.propTypes = {
  task: taskShape.isRequired,
  taskName: string.isRequired,
  onUpdateTaskStatus: func.isRequired,
  loading: bool.isRequired,
  onRequest: func.isRequired,
};

export default withApiRequest({
  query: api.getTask,
  error: 'flash',
})(TaskStatus);
